// extracted by mini-css-extract-plugin
export default {"ExperienceBox":"Experience_ExperienceBox__UWwS-"};